import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPropertiesWithNotifications, updatePropertyNotifications } from '../../../data/reducers/emailPreferencesReducer';
import './EmailPreferences.css';

const ManageNotifications = () => {
  const { token } = useParams();
  const dispatch = useDispatch();

  const {
    properties,
    isFetchingProperties,
    isUpdatingProperties,
    tokenValid,
    error,
    success
  } = useSelector(state => state.emailPreferences);

  // Property selection state (will be initialized from backend data)
  const [selectedProperties, setSelectedProperties] = useState({});

  useEffect(() => {
    if (token) {
      dispatch(fetchPropertiesWithNotifications(token));
    }
  }, [dispatch, token]);

  // Update local state when properties are loaded from backend
  useEffect(() => {
    if (properties && properties.length > 0) {
      const initialState = {};
      properties.forEach(property => {
        initialState[property.property_id] = property.is_enabled;
      });
      setSelectedProperties(initialState);
    }
  }, [properties]);

  const toggleProperty = (propertyId) => {
    setSelectedProperties(prev => ({
      ...prev,
      [propertyId]: !prev[propertyId]
    }));
  };

  const handleSave = async () => {
    // Convert state to array format for API
    const propertyNotifications = Object.keys(selectedProperties).map(propertyId => ({
      property_id: parseInt(propertyId),
      is_enabled: selectedProperties[propertyId]
    }));

    try {
      await dispatch(updatePropertyNotifications(token, propertyNotifications));
      // Redirect to homepage after successful save
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    } catch (error) {
      console.error('Failed to save preferences:', error);
    }
  };

  if (token && (isFetchingProperties || tokenValid === null)) {
    return (
      <div className="email-preferences-scope violerts-email-preferences-container">

        <div className="violerts-email-preferences-card">
          <div style={{textAlign: 'center', padding: '40px'}}>
            <div className="loading-spinner"></div>
            Loading your properties...
          </div>
        </div>
      </div>
    );
  }

  if (tokenValid === false && !isFetchingProperties) {
    return (
      <div className="email-preferences-scope violerts-email-preferences-container">

        <div className="violerts-email-preferences-card">
          <div style={{textAlign: 'center'}}>
            <div style={{fontSize: '60px', marginBottom: '20px'}}>😞</div>
            <h2 className="violerts-email-preferences-title">Oops, looks like this link is invalid</h2>
            <p className="violerts-email-preferences-subtitle">{error || 'This link is invalid or has expired.'}</p>
            <div className="violerts-email-preferences-button-container">
              <button
                className="violerts-email-preferences-btn"
                onClick={() => window.location.href = '/'}
              >
                Go to Homepage
              </button>
            </div>
          </div>
        </div>
        <div className="violerts-email-preferences-footer">
          2025 Violerts. All rights reserved.
        </div>
      </div>
    );
  }

  return (
    <div className="email-preferences-scope violerts-email-preferences-container">


      <div className="violerts-email-preferences-card manage-notifications-card">
        <h2 className="violerts-email-preferences-title">Manage My Notifications / Alerts</h2>

        {error && (
          <div style={{backgroundColor: '#ffebee', border: '1px solid #f44336', borderRadius: '4px', padding: '10px', marginBottom: '20px', color: '#d32f2f', fontSize: '14px'}}>
            {error}
          </div>
        )}

        {success && (
          <div style={{backgroundColor: '#e8f5e8', border: '1px solid #4caf50', borderRadius: '4px', padding: '10px', marginBottom: '20px', color: '#2e7d32', fontSize: '14px'}}>
            {success}
          </div>
        )}

        <form>
          {/* Property Listing with Checkboxes */}
          {properties && properties.length > 0 ? (
            properties.map((property) => {
              const portfolioNames = (property.portfolios ?? []).map(p => p.portfolio_name).join(', ');
              return (
                <div key={property.property_id} className="manage-property-section">
                  <div className="manage-property-header">
                    <label className="violerts-email-preferences-checkbox-container property-checkbox">
                      <input
                        type="checkbox"
                        className="violerts-email-preferences-checkbox-input"
                        checked={selectedProperties[property.property_id] || false}
                        onChange={() => toggleProperty(property.property_id)}
                        disabled={isUpdatingProperties}
                      />
                      <span className="violerts-email-preferences-checkmark"></span>
                      <span className="violerts-email-preferences-checkbox-label property-title">
                        <span className="property-name-line">{property.property_name}</span>
                        {!!portfolioNames && (
                          <span className="property-portfolios-line">{portfolioNames}</span>
                        )}
                      </span>
                    </label>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{textAlign: 'center', padding: '20px', color: '#999'}}>
              No properties found
            </div>
          )}

          {/* Action Buttons */}
          <div className="violerts-email-preferences-button-container">
            <button
              type="button"
              className="violerts-email-preferences-btn email-prefs-btn-primary"
              onClick={handleSave}
              disabled={isUpdatingProperties}
            >
              {isUpdatingProperties ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>

      <div className="violerts-email-preferences-footer">
        2025 Violerts. All rights reserved.
      </div>
    </div>
  );
};

export default ManageNotifications;